import de from './de'
import en from './en'
import pl from './pl'
import ro from './ro'

const locales = { de, en, pl, ro }

export const availableLocales = Object.fromEntries(Object.entries(locales).map(([key, messages]) => [key, messages._localeName || key]))

export default locales
